module.exports = __webpack_public_path__ + "app-static/img/yzf.ac6f4fcd.png";